import { Component, Input, Inject, HostListener } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { DOCUMENT } from '@angular/common';
import { AuthState } from '../../auth/auth.types';
import { Observable } from 'rxjs';

@Component({
  selector: 'auth-flow',
  templateUrl: './auth-flow.component.html',
  styleUrls: ['./auth-flow.component.css']
})
export class AuthFlowComponent {
  @Input() authState$: Observable<AuthState>;
  dropdownOpen = false;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private auth: AuthService
  ) {}

  login() {
    this.auth.loginWithRedirect();
  }

  logout() {
    this.auth.logout({ returnTo: this.document.location.origin });
    this.dropdownOpen = false;
  }

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    const clickedInside = target.closest('.user-dropdown');
    if (!clickedInside) this.dropdownOpen = false;
  }
}